<div class="container mx-auto max-w-2xl space-y-6 px-4 py-8">
  <header class="flex flex-col items-center gap-3 text-center">
    <app-logo [widthInPx]="120" />
    <div>
      <h1 hlmH3>Gutschein prüfen</h1>
      <p hlmMuted class="mt-1">Guthaben ansehen und einlösen</p>
    </div>
  </header>

  @if (loading) {
    <hlm-skeleton class="h-56 w-full rounded-xl" />
  }

  @if (error && !loading) {
    <div hlmAlert variant="destructive">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>{{ error }}</p>
    </div>
    <button hlmBtn variant="outline" class="w-full" (click)="goHome()">Zur Startseite</button>
  }

  @if (voucher && !loading && !error) {
    <app-voucher-balance-card
      [code]="voucher.code"
      [subtitle]="voucher.company_name"
      [status]="voucher.status"
      [amount]="voucher.amount"
      [initialAmount]="voucher.initial_amount"
      [product]="voucher.voucher_product_data" />

    @if (showRedemption) {
      <app-redemption-flow
        [code]="voucher.code"
        [balance]="voucher.amount"
        [location]="selectedLocationName"
        [ready]="redemptionReady"
        [busy]="redeeming"
        [error]="redemptionError"
        [errorTitle]="getErrorTitle()"
        [locked]="isBlocked()"
        [result]="redemptionResult"
        (confirmed)="redeemVoucher($event)"
        (continued)="continueRedemption()"
        (errorDismissed)="redemptionError = ''">
        @if (hasGroupMembers || loadingMembers) {
          <div hlmField>
            <label hlmFieldLabel for="member-select">Einlösestandort</label>
            @if (loadingMembers) {
              <p hlmFieldDescription>Standorte werden geladen…</p>
            } @else {
              <hlm-native-select
                selectId="member-select"
                class="w-full"
                [disabled]="redeeming"
                [(ngModel)]="selectedMemberCompanyId">
                <option hlmNativeSelectOption [value]="null">– Standort auswählen –</option>
                <!-- Members without a PIN are listed but can't be picked: their staff
                     see why the location is missing instead of trying another PIN -->
                @for (member of networkMembers; track member.id) {
                  <option
                    hlmNativeSelectOption
                    [value]="member.company_id"
                    [disabled]="!member.has_pin">
                    {{ member.company_name }}{{ member.has_pin ? '' : ' (kein PIN)' }}
                  </option>
                }
              </hlm-native-select>
            }
          </div>
        }

        <div hlmField>
          <label hlmFieldLabel for="redemption-pin">Einlöse-PIN</label>
          <input
            hlmInput
            id="redemption-pin"
            type="password"
            inputmode="numeric"
            autocomplete="off"
            maxlength="6"
            placeholder="PIN eingeben"
            class="w-full"
            [disabled]="redeeming"
            [(ngModel)]="redemptionPin" />
          <p hlmFieldDescription>Den PIN kennt das Personal im Geschäft.</p>
        </div>
      </app-redemption-flow>
    }

    <!-- ══════════ Locations ══════════ -->
    @if (redemptionLocations.length > 0) {
      <section hlmCard>
        <div hlmCardHeader>
          <h2 hlmCardTitle>Einlösestandorte</h2>
          <p hlmCardDescription>Hier kann dieser Gutschein eingelöst werden.</p>
        </div>

        <div hlmCardContent>
          <div hlmItemGroup class="gap-2">
            @for (location of redemptionLocations; track location.id) {
              <div hlmItem variant="outline" size="sm">
                <div hlmItemMedia variant="image">
                  @if (location.logo_image_path) {
                    <img
                      [src]="getLogoUrl(location.logo_image_path)"
                      [alt]="location.company_name" />
                  } @else {
                    <ng-icon name="lucideStore" />
                  }
                </div>
                <div hlmItemContent>
                  <span hlmItemTitle>{{ location.company_name }}</span>
                  @if (location.street || location.city) {
                    <span hlmItemDescription>
                      {{ location.street ? location.street + ', ' : '' }}{{ location.zip }}
                      {{ location.city }}
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    }

    <app-voucher-timeline
      [createdAt]="voucher.created_at"
      [expiresAt]="voucher.expires_at"
      [redemptions]="voucher.redemptions" />
  }
</div>
